import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileAudio = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.998 18.5c0 1.38-1.343 2.5-3 2.5s-3-1.12-3-2.5 1.343-2.5 3-2.5 3 1.12 3 2.5m0 0V7.488a2 2 0 0 1 1.425-1.916l6-1.8a2 2 0 0 1 2.575 1.916V15.5m0 0c0 1.38-1.343 2.5-3 2.5s-3-1.12-3-2.5 1.343-2.5 3-2.5 3 1.12 3 2.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='m19.232 14.186.77.495v-9.99a.75.75 0 0 0-.956-.721l-8.502 2.429a.75.75 0 0 0-.544.72v12.246c0 1.555-1.494 2.75-3.25 2.75S3.5 20.92 3.5 19.365s1.494-2.75 3.25-2.75c.72 0 1.417.209 1.98.57l.77.497V7.12c0-.558.37-1.049.907-1.202l8.502-2.429a1.25 1.25 0 0 1 1.593 1.202v11.674c0 1.555-1.494 2.75-3.25 2.75s-3.25-1.195-3.25-2.75 1.494-2.75 3.25-2.75c.72 0 1.417.209 1.98.57'
        fill='currentColor'
        stroke='currentColor'
      />
    )}
  </IconBase>
);
